import { ParamValidator, ValidationError } from '/validation/param_validator.js'; // <-- the new shared validator

const MAX_NAME_LENGTH = 100;
const MAX_DESCRIPTION_LENGTH = 65535;
const MAX_TAG_LENGTH = 50;

const previewIsValidDictionary = {
    'YT_URL' : isValidYoutubePreview,
    'SCL_URL' : isValidSoundCloudPreview,
    'PIC_FILE' : isValidPicFilePreview,
    'IDEA' : isValidIdeaPreview
}

function isValidPreview(previewObject) {
    if (!previewObject) return false;

    const method = previewObject.method;
    
    const isValidPreviewFunction = previewIsValidDictionary[method];

    if(!(isValidPreviewFunction instanceof Function)) return false;
    return isValidPreviewFunction(previewObject);
}

function isValidYoutubePreview(previewObject) {
    const method = previewObject.method;
    if (!method || method !== 'YT_URL') return false;
  
    const videoId = ParamValidator.basicSanitize(previewObject.videoId);
  
    if (!ParamValidator.isValidYoutubeVideoId(videoId)) return false;
    if (!/^[a-zA-Z0-9_-]{5,20}$/.test(videoId)) return false;
  
    previewObject.videoId = videoId;
    return true;
}

function isValidSoundCloudPreview(previewObject) {
    const method = previewObject.method;
    if (!method || method !== 'SCL_URL') return false;
  
    const trackId = ParamValidator.basicSanitize(previewObject.trackId);
  
    if (!ParamValidator.isValidSoundCloudTrackId(trackId)) return false;
  
    previewObject.trackId = trackId;
    return true;
}

function isValidPicFilePreview(previewObject) {
    const method = previewObject.method;
    if (!method || method !== 'PIC_FILE') return false;

    const storageLink = ParamValidator.basicSanitize(previewObject.key);

    if(!ParamValidator.isValidStorageFileLink(storageLink)) return false;
  
    previewObject.key = storageLink;
    return true;
}

function isValidIdeaPreview(previewObject) {
    const method = previewObject.method;
    if (!method || method !== 'IDEA') return false;
  
    const numberOfFields = Object.keys(previewObject).length;

    return numberOfFields===1;
}

function isValidResourceLink(linkObj) {
    console.log("linkObj ", linkObj);
    
    if (!linkObj) return false;
    return (
        ParamValidator.isValidLink(linkObj.link) &&
        ParamValidator.isSafeTextNullable(linkObj.commentary, 500)
    );
}

export function isValidBranch(obj) {
    if (!obj) throw new Error("No update data provided");

  // Sanitize strings using ParamValidator
    const sanitized = {
        preview: obj.preview,
        name: ParamValidator.basicSanitize(obj.name),
        description: ParamValidator.basicSanitize(obj.description),
        resources: obj.resources?.map(l => ({
            link: ParamValidator.normalizeLink(ParamValidator.basicSanitize(l.link)),
            commentary: ParamValidator.basicSanitize(l.commentary)
        })) ?? null,
        tags: obj.tags?.map(tag => ParamValidator.basicSanitize(tag)) ?? null
    };


    // --- Validate fields ---
    if (!isValidPreview(sanitized.preview))
        throw new ValidationError("Something's wrong with your preview");

    if (sanitized.name && !ParamValidator.isValidText(sanitized.name, MAX_NAME_LENGTH))
        throw new ValidationError("Your branch name is either too long or contains inappropriate characters");

    if (sanitized.description && !ParamValidator.isSafeTextNullableExpanded(sanitized.description, MAX_DESCRIPTION_LENGTH))
        throw new ValidationError("Your branch description is either too long or contains inappropriate characters");

    if (sanitized.resources?.length) {
        console.log("sanitized.resources ", sanitized.resources);
        for (const resource of sanitized.resources) {
            if (!isValidResourceLink(resource))
                throw new ValidationError(`Something about your link ${resource.link.substring(0, 5)}... makes it inappropriate`);
        }
    }

    if (sanitized.tags?.length) {
        for (const tag of sanitized.tags) {
            if (!ParamValidator.isValidText(tag, MAX_TAG_LENGTH))
                throw new ValidationError(`Your tag ${tag} is either too long or contains inappropriate characters`);
        }
    }

    return sanitized;
}